import {
  SHOPIFY_SALES_REFERRER_ALL_SUCCESS,
  SHOPIFY_SALES_REFERRER_ALL_LOADING,
  } from '../actions/SalesByReferrerAllAction';
  
  const initialState = {
    SalesByReffererAllData: [],
    isAllLoading: true
  };
  
  const SalesByReferrerAllReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case SHOPIFY_SALES_REFERRER_ALL_SUCCESS:
        return { ...state, SalesByReffererAllData: action.data, isAllLoading: false };
      case SHOPIFY_SALES_REFERRER_ALL_LOADING:
        return { ...state, isLoading: action.isAllLoading };
      default:
        return state;
    }
  };
  
  export default SalesByReferrerAllReducer;
  